export default "__VITE_ASSET__MFao8FXv__"